import { makeStyles, styled } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { THEME } from 'GlobalStyles';
import { FPIconButton } from 'UI/components/atoms';
import { getDarkUnfilledIconStyles } from 'UI/theme/darkTones';
import { flexAlignCenterJustifyCenter, rippleEffect } from 'UI/utils/styles';

const PHONE_ACTION_SHARED_STYLES = {
  ...flexAlignCenterJustifyCenter,
  padding: THEME.spacing(0.5, 1.2),
  borderRadius: '100%',
  width: '44px',
  height: '44px'
};

const rippleColor = '#717172';

export const useStyles = makeStyles(theme => ({
  arrowButton: getDarkUnfilledIconStyles(theme, theme.palette.action.active)
}));

export const Container = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  '& .MuiTypography-root': {
    marginRight: theme.spacing(1)
  }
}));

export const PhoneActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 0,
  paddingLeft: theme.spacing(1)
}));

export const PhoneActionLink = styled('a')(({ theme, disabled }) => ({
  ...(disabled ? {} : rippleEffect(theme.palette.grey[300], rippleColor)),
  ...PHONE_ACTION_SHARED_STYLES,
  pointerEvents: disabled ? 'none' : 'auto',
  opacity: disabled ? 0.5 : 1
}));

export const PhoneActionButton = styled(FPIconButton)(() => PHONE_ACTION_SHARED_STYLES);

export const MenuItemLoaderContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  minWidth: 150,
  padding: theme.spacing(1)
}));

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  justifyContent: 'space-between',
  paddingBottom: theme.spacing(0.5),
  paddingTop: theme.spacing(0.5)
}));
